import { Button, ButtonLabel } from "@similarweb/ui-components";
import type * as React from "react";
import styled from "styled-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { Footer } from "pro-features/components/OptIn/components/SelectWorkspaceTrialModal";
import { colorsPalettes } from "@similarweb/styles";

interface IResetBetaBranchFlagModalProps {
    isOpen: boolean;
    onCloseClick: () => void;
    onContinueClick: () => void;
    title: string;
    subtitle?: string;
    continueLabel: string;
    closeLabel: string;
}
const modalStyle: any = {
    customStyles: {
        content: {
            boxSizing: "content-box",
            width: "500px",
            padding: "0px",
        },
    },
};

const ModalTitle = styled.div.attrs(
    (props) =>
        ({
            "data-automation": "reset-beta-modal-title",
        } as any),
)`
    color: ${colorsPalettes.carbon["500"]};
    font-weight: 500;
    margin-top: 5px;
    font-size: 20px;
    margin-bottom: 24px;
    line-height: 24px;
`;

const ModalSubtitle = styled.div.attrs(
    (props) =>
        ({
            "data-automation": "reset-beta-modal-subtitle",
        } as any),
)`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 12px;
    max-width: 90%;
    display: flex;
    color: ${colorsPalettes.carbon["300"]};
`;

const TextContainer = styled.div`
    display: block;
    padding: 24px;
`;

const StyledFooter = styled(Footer)`
    padding: 12px 24px;
    margin-top: 0px;
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
`;

export const ResetBetaBranchFlagModal: React.FC<IResetBetaBranchFlagModalProps> = (
    props: IResetBetaBranchFlagModalProps,
) => {
    const { isOpen, onCloseClick, onContinueClick, continueLabel, closeLabel, title, subtitle } = props;

    return (
        <ProModal
            isOpen={isOpen}
            onCloseClick={onCloseClick}
            showCloseIcon={false}
            {...modalStyle}
        >
            <TextContainer>
                <ModalTitle>{i18nFilter()(title)}</ModalTitle>
                {subtitle && <ModalSubtitle>{i18nFilter()(subtitle)}</ModalSubtitle>}
            </TextContainer>
            <StyledFooter>
                <Button
                    onClick={onCloseClick}
                    type="flat"
                >
                    <ButtonLabel>{i18nFilter()(closeLabel)}</ButtonLabel>
                </Button>
                <Button
                    onClick={onContinueClick}
                    type="primary"
                >
                    <ButtonLabel>{i18nFilter()(continueLabel)}</ButtonLabel>
                </Button>
            </StyledFooter>
        </ProModal>
    );
};

const StyledModalSubtitle = styled(ModalSubtitle)`
    max-width: 70%;
`;
